import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import "./style.css"

function Slider({ images }) {
    const location = useLocation();
    const [counter, setCounter] = useState(0);
    const [className, setClassName] = useState('slider');

    useEffect(() => {
        if (location) {
            const path = location.pathname.split('/');
            if (path[1] && path[1] === 'article') setClassName('slider_cube');
        }
    }, [location])

    return (
        <div className={className}>
            <div className="view">
                <i style={{ backgroundImage: `url(${images[counter].url})` }}></i>
            </div>

            <div className="panel_slider">
                {images.map((img, idx) => (
                    <button
                        key={idx}
                        className="slide"
                        onClick={() => setCounter(idx)}
                    >
                        <i style={{ backgroundImage: `url(${img._url})` }}></i>
                    </button>
                ))}
            </div>
        </div>
    )
}

export default Slider;